export default "__VITE_PUBLIC_ASSET__ba174e96__"